module.exports = __webpack_public_path__ + "static/media/estate.538db7e7.png";